

import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "./usermanagement.css";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { bottom } from "@popperjs/core";
import dummyProfile from "../../assets/images/lady.png";

import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import TextArea from "../../components/TextArea";

import {
  extractDate,
  extractOnlyDate,
  maskToken,
  maskSocialSecurityNumber,
  uploadImage,
  subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import Checkbox from '@mui/material/Checkbox';
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaginationItem from '@mui/material/PaginationItem';
import { TextField, Popover, Box } from "@mui/material";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";

import Verified from "../../assets/images/verification.png";

// icons
import { IoIosLink } from "react-icons/io";
import { IoCallOutline } from "react-icons/io5";
import { IoLocationOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { LuContact } from "react-icons/lu";
import { GoCalendar } from "react-icons/go";
import { SlPencil } from "react-icons/sl";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { PiAndroidLogoFill } from "react-icons/pi";

import { SlClose } from "react-icons/sl";
import { RxCross2 } from "react-icons/rx";
import { FaArrowLeft } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline, TiTick } from "react-icons/ti";
import { BiSolidPackage } from "react-icons/bi";
import { RxCrossCircled } from "react-icons/rx";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { GrApple, GrAndroid } from "react-icons/gr";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { PiHandsClappingBold, PiUserList, PiXCircleFill } from "react-icons/pi";

import {
  MdBlock,
  MdClose,
  MdEmail,
  MdLocalPhone,
  MdPhone,
} from "react-icons/md";
import {
  IoArchive,
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
} from "react-icons/io5";
import {
  FaFilter,
  FaGlobe,
  FaPhone,
  FaUser,
  FaUserAlt,
  FaMoneyBill,
  FaCheckCircle,
} from "react-icons/fa";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  ProfileDetailForm,
  ServiceDetailForm,
  DashHeading,
  Button,
  Filter,
  DpBox,
  Fields,
  Resetbtn,
  Applybtn,
} from "./UserManagementElements";
import android from "../../assets/images/Androide.png";

const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 10px', // adds vertical spacing between rows
  },
  tableMainContainer: {
    maxHeight: "50vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",
    border: "1px solid rgba(17, 153, 38, 0.20)",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    // padding: "0.4rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"
  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));



const RegistrationDetails = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "User Management"
  )?.permissions || {};

  const canDelete = !!userManagementPermissions.delete;

  const param = useParams();
  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [userinfo, setUserInfo] = useState();

  const [acceptRejectModal, setAcceptRejectModal] = useState(false);
  const [reasonDeleteModal, setReasonDeleteModal] = useState(false);
  const [actionType, setActionType] = useState(""); // "accept" or "reject"
  const [showRejectionReason, setShowRejectionReason] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [profileChecked, setProfileChecked] = useState(false);
  const [documentChecked, setDocumentChecked] = useState(false);
  const [profileRejectionReason, setProfileRejectionReason] = useState("");
  const [documentRejectionReason, setDocumentRejectionReason] = useState("");
  const [userHistory, setUserHistory] = useState();
  const [anchorEl, setAnchorEl] = useState(null);





  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };

  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;





  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    // handleCancel();
    setPage(newPage); // Update page and trigger data fetch
  };




  // For Select checkbox
  const [selectedRows, setSelectedRows] = useState([]);


  useEffect(() => {
    if (tableData.length === 0) {
      setSelectedRows([]);
    }
  }, [tableData]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(tableData.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    const newSelectedRows = selectedRows.includes(id)
      ? selectedRows.filter((rowId) => rowId !== id)
      : [...selectedRows, id];
    setSelectedRows(newSelectedRows);
  };

  const handleClearSelection = () => {
    setSelectedRows([]);
  };


  const [verificationDocumentModal, setVerificationDocumentModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(""); // Store clicked image source

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setVerificationDocumentModal(true);
  };


  //  this is for open history
  const handleClick = () => {
    setShowTable(!showTable);
  };




  // Get user detail data
  useEffect(() => {
    getUserDetails();
    getUserHistory();
  }, []);

  const getUserDetails = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.get(`/private/getUserDetails/${param?.id}`);

      setUserDetails(data?.data[0]);
      setUserInfo(data?.data[0])
      console.log("datadatadatadata",data)
    
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  // userViewHistory

  const getUserHistory = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.get(`/private/userViewHistoryfind/${param?.id}`);
      setUserHistory(data?.data);
      // setUserHistoryDeteil(data?.data[1]);

    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  // approve && Reject
  const handleApprove = async () => {
    setIsLoading(true)
    try {
      const response = await axios.post(
        `/private/approvedUser/${param?.id}`,
        {
          status: "2",
          profileStatus: "2",
          documentStatus: "2"
        }
      );
      console.log("Approved successfully", response.data);
      navigate("/userManagement");

    } catch (error) {
      console.error("Error approving user:", error);
    } finally {
      setIsLoading(false);
    }
  };



  const handleSubmit = () => {

    if (!profileChecked && !documentChecked) {
      toast.error("Please select at least one option.", { position: "top-right" });
      return;
    }

    if (profileChecked && !profileRejectionReason.trim()) {
      toast.error("Please enter a reason for profile.", { position: "top-right" });
      return;
    }
    if (documentChecked && !documentRejectionReason.trim()) {
      toast.error("Please enter a reason for document.", { position: "top-right" });
      return;
    }
    // Prepare payload for API
    const reasonPayload = {
      profileStatus: profileChecked ? "3" : "2",
      documentStatus: documentChecked ? "3" : "2",
      // profileRejectionReason: profileChecked ? profileRejectionReason : "",
      // documentRejectionReason: documentChecked ? documentRejectionReason : ""
      ...(profileChecked ? { profileRejectionReason } : {}),
      ...(documentChecked ? { documentRejectionReason } : {})
    };

    handleReasonSubmit(reasonPayload);
    setReasonDeleteModal(false);
  };

  const handleReasonSubmit = async (payload) => {
    try {
      const res = await axios.post(`/private/approvedUser/${param?.id}`, {
        status: "3",
        ...payload
      });
      toast.success("Rejected");
      navigate('/registrationRequest')
      console.log("Rejected with reason", res.data);
    } catch (error) {
      console.error("Error rejecting user:", error.response?.data || error.message);
    }
  };




  const backRoute =
    location.state?.from === "registrationRequest"
      ? "/registrationRequest"
      : location.state?.from === "verificationRequestDetails"
        ? "/serviceProviderStatus"
        : "/serviceFeedback";


  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm style={{ gap: "1rem" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer"

              }}
            >
              <div
                onClick={() => navigate(backRoute)}
              // onClick={() => navigate("/registrationRequest")}
              >
                <HiArrowNarrowLeft style={{ fontSize: "1.2rem" }} />
                <span className="common-heading ps-2"> {userDetails?.fullName}'s Profile</span>
              </div>

              {
                (userDetails?.isStripeProfileVerified != "1") &&
                (userDetails?.documentStatus === "1" ||
                  userDetails?.profileStatus === "1")
                && (
                  <div style={{ display: "flex", gap: "5px" }}>
                    <button className="reject_button" onClick={() => setAcceptRejectModal(true)}>Reject</button>
                    <button className="accept_button" onClick={handleApprove}>Approve</button>
                  </div>
                )}
            </div>



            <div className="user_data">
              <div className="user_card_1">
                <p className="common-heading ">{userDetails?.fullName || "N/A"}</p>
                <span style={{ display: "flex", gap: "1rem", color: "#484848", fontWeight: "500", fontSize: "14px" }}>
                  <LuContact className="user_icons" />
                  {userDetails?.userId}
                  <GoCalendar className="user_icons" />
                  {extractDate(userDetails?.createdAt) || "N/A"}
                </span>
                <div style={{ display: "flex", gap: "15px", }}>
                  {/* alignItems:"baseline", */}

                  <div><SlPencil className="user_icons" style={{ marginTop: "15px" }} />  </div>
                  <div
                    style={{
                      marginTop: "15px",
                      display: "flex",
                      gap: "1rem",
                      color: "#484848",
                      fontWeight: "400",
                      fontSize: "16px",
                      overflowWrap: "anywhere"
                    }}>
                    {userDetails?.bio || "N/A"}
                  </div>
                </div>
              </div>
              <div className="user_card_2">
                <div className="main_user" ><AiOutlineMail className="user_icons" /> <span style={{ color: "#2960C0", fontWeight: "400", fontSize: "14px", fontFamily: "Roboto" }}>
                  {userDetails?.email ? (
                    <>
                      {userDetails.email} <img src={Verified} alt="Verified" />
                    </>
                  ) : (
                    "N/A"
                  )}
                </span>
                </div>
                <div className="main_user"><IoCallOutline className="user_icons" /> <span style={{ color: "#000000", fontWeight: "400", fontSize: "14px" }}>
                  {userDetails?.phoneNumber ? (
                    <>
                      {userDetails?.countryCode} {userDetails?.phoneNumber} <img src={Verified} alt="Verified" />
                    </>
                  ) : (
                    "N/A"
                  )}
                </span>
                </div>
                <div className="main_user"><IoIosLink className="user_icons" /> <span style={{ color: "#2960C0", fontWeight: "400", fontSize: "14px", fontFamily: "Roboto" }}> {userDetails?.websiteUrl || "N/A"}</span></div>
                <div className="main_user"><IoLocationOutline className="user_icons" /> <span style={{ color: "#000000", fontWeight: "400", fontSize: "14px", fontFamily: "Roboto" }}>{userDetails?.zipCode || "N/A"}</span></div>
              </div>
            </div>





            <div className="main_card">
              <div>
                <p className="info_hadding">Personal Information</p>
                <div className="user-data">
                  <p className="info_border">Username <span>{userDetails?.userName}</span></p>
                  <p className="info_border">Qualification <span>{userDetails?.educationQualification}</span></p>
                  <p className="info_border">Date of Birth <span>{extractOnlyDate(userDetails?.dateOfBirth)}</span></p>
                  <p className="info_border">Device Type <span>

                    {userDetails?.sessionData?.deviceType === "android" ? (
                      <img src={android} style={{ width: "22px", height: "22px" }} />
                    ) : userDetails?.sessionData?.deviceType === "ios" ? (
                      <GrApple style={{ fontSize: "20px", color: "#424245" }} />
                    ) : (
                      "Logged Out"
                    )}
                  </span></p>
                  <p className="info_border">Device Name <span>{userDetails?.sessionData?.deviceName || 'N/A'}</span></p>
                  <p className="info_border" style={{ border: "none" }}>SSN No. <span>XXXXX{userDetails?.ssnlast4?.slice(-4)}</span></p>
                </div>
              </div>
              <div>
                <p className="info_hadding">{userDetails?.documents?.documentType}</p>
                <div className="id_card">
                  <div className="view_id">
                    <p>Front View</p>
                    <div className="id_upload">
                      {/* <img src={userDetails?.documents?.backImage?.value} style={{ height: "211px", width: "330px", borderRadius: "18px" }} /> */}
                      <img
                        src={userDetails?.documents?.frontImage?.value}

                        className="license-img"
                        onClick={() => handleImageClick(userDetails?.documents?.frontImage?.value)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                  <div className="view_id">
                    <p>Back View</p>
                    <div className="id_upload">
                      {/* <img src={userDetails?.documents?.frontImage?.value} style={{ height: "211px", width: "330px", borderRadius: "18px" }} /> */}
                      <img
                        src={userDetails?.documents?.backImage?.value}
                        className="license-img"
                        onClick={() => handleImageClick(userDetails?.documents?.backImage?.value)}
                        style={{ cursor: "pointer" }}
                      />

                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "10rem" }}>
                <button
                  onClick={handleClick}
                  style={{
                    background: "#5088FB",
                    color: "#FFFFFF",
                    fontFamily: "Inter",
                    fontWeight: "400",
                    fontSize: "14px",
                    padding: "0.5rem",
                    border: "none",
                    borderRadius: "2px",
                  }}
                >
                  View History
                </button>
              </div>
            </div>

            {showTable && (

              <TableContainer
                className={classes.tableMainContainer}
              >
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow className={classes.tableHeadingRow} >
                      <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Request Date</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Request Status</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Request Updated Time</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Request Updated By</TableCell>
                    </TableRow>
                  </TableHead>
                  {userHistory && userHistory.length > 0 ? (
                    <>
                      <TableBody>
                        {userHistory.map((user, index) => (
                          <TableRow className={classes.tableBodyRow} key={user._id} >
                            <TableCell className={classes.textMiddle}>
                              {index + 1 + rowsPerPage * (page - 1)}
                            </TableCell>
                            <TableCell className={classes.textMiddle}>
                              {extractOnlyDate(get(user, "requestDate", "---"))}
                            </TableCell>
                            <TableCell className={classes.textMiddle}>
                              {/* {(get(user, "requestStatus", "---"))} */}
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }} >
                                <button className="block-btn">
                                  {user.requestStatus === "3" ? "Rejected" : null}
                                </button>
                                <div className="view_reason"
                                  onClick={(e) => {
                                    setUserInfo(user);
                                    handleFilterClick(e)
                                  }}
                                >View Reason</div>
                              </div>
                            </TableCell>
                            <TableCell className={classes.textMiddle}>
                              {extractDate(get(user, "requestUpdatedTime", "---"))}
                            </TableCell>
                            <TableCell className={classes.textMiddle}>
                              {get(user, "requestUpdatedBy", "---")}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </>
                  ) : (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={13} align="center" style={{ padding: "2rem" }}>
                            <DashHeading style={{ textAlign: "center", padding: "2rem", color: "#0000000" }}>No Data Found !!</DashHeading>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  )}
                </Table>
              </TableContainer>

            )}


          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {/* Modal for Reject User  */}
      <Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={acceptRejectModal}
        onClose={() => {
          setAcceptRejectModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-center">
              <RxCross2
                style={{
                  cursor: "pointer",
                  background: "#EA5455",
                  color: "#FFFFFF",
                  borderRadius: "50%",
                  fontSize: "2rem",
                  padding: "0.5rem",
                  marginTop: "1rem",
                  // textAlign: "center"                        

                }}
                onClick={() => { setAcceptRejectModal(false); }}
              />
            </div>
            <p className="reject_request">Reject {userDetails?.fullName} Request</p>
            <div className="logout-header">Are you sure you want to reject this request? The JobDash will not be granted access to the platform</div>
          </div>
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="logout-button"
                style={{ background: "#EA5455", cursor: "pointer" }}
                onClick={() => {
                  setReasonDeleteModal(true);
                  setAcceptRejectModal(false);
                }}
              >
                Yes
              </div>
              <div
                className="cancel-button"
                onClick={() => {
                  setAcceptRejectModal(false);
                }}
              >
                Cancel
              </div>
            </div>
          </>
        }
      />

      {/* Modal for reason User  */}

      <Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={reasonDeleteModal}
        onClose={() => setReasonDeleteModal(false)}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setReasonDeleteModal(false)} />
            </div>
            <p className="profile-section-text">Select Reason</p>

            {/* Profile */}
            <div className="reason-field">
              <label className="profile">
                <input
                  type="checkbox"
                  checked={profileChecked}
                  onChange={(e) => setProfileChecked(e.target.checked)}
                  style={{ width: "18px", height: "18px" }}
                /> <span>Profile</span>
              </label>
              <span style={{ marginTop: "-12px", fontSize: "10px", color: 'red', marginLeft: "24px" }}>It includes First name, Last name, User Name, DOB and Zip code</span>
            </div>

            {profileChecked && (
              <textarea
                name="profile"
                className="reject_form"
                placeholder="Enter profile reason"
                type="textarea"
                maxLength={100}
                value={profileRejectionReason}
                onChange={(e) => setProfileRejectionReason(e.target.value)}
                style={{ border: "1px solid #D9D9D9", color: "#484848", fontSize: "13px", fontFamily: "Roboto", fontWeight: "400" }}
              />
            )}

            <div className="reason-field">
              <label className="profile">
                <input
                  type="checkbox"
                  checked={documentChecked}
                  onChange={(e) => setDocumentChecked(e.target.checked)}
                  style={{ width: "18px", height: "18px" }}
                /> Document
              </label>
              <span style={{ marginTop: "-12px", fontSize: "10px", color: 'red', marginLeft: "24px" }}>It include Bio, Website URL and Documents.</span>
            </div>

            {/* Document */}
            {documentChecked && (
              <textarea
                name="document"
                className="reject_form"
                placeholder="Enter document reason"
                maxLength={100}
                value={documentRejectionReason}
                onChange={(e) => setDocumentRejectionReason(e.target.value)}
                style={{ border: "1px solid #D9D9D9", color: "#484848", fontSize: "13px", fontFamily: "Roboto", fontWeight: "400" }}
              />
            )}
          </div>
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="logout-button"
                style={{ background: "#5088FB", cursor: "pointer" }}
                onClick={handleSubmit}
              >
                Submit
              </div>
              <div className="cancel-button" onClick={() => setReasonDeleteModal(false)}>
                Cancel
              </div>
            </div>
          </>
        }
      />


      {/* Modal for Showing Document */}
      {verificationDocumentModal && (
        <Modal
          maxWidth="lg"
          width="500px"
          RoundedCorners={true}
          isOpen={verificationDocumentModal}
          onClose={() => setVerificationDocumentModal(false)}
          backgroundModal={false}
          backgroundModalContent={false}
          title={
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2
                style={{ cursor: "pointer" }}
                onClick={() => setVerificationDocumentModal(false)}
              />
            </div>
          }
          content={
            <div className="send-take-pkg-cant text-center">
              <div className="common-heading">Document Image</div>
              <img
                src={selectedImage}
                alt="Selected Document"
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  borderRadius: "10px",
                  marginTop: "1rem"
                }}
              />
            </div>
          }
        />
      )}


      {/* Popover for user info */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, width: "350px" }}>
          <div>
            <p className="user_info">Rejected Reason</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                {userinfo?.profileReason && (
                  <div>
                    Profile:&nbsp;
                    <span style={{ color: "red" }}>
                      {userinfo?.profileReason}
                    </span>
                  </div>
                )}

                {userinfo?.documentReason && (
                  <div>
                    Document:&nbsp;
                    <span style={{ color: "red" }}>
                      {userinfo?.documentReason}
                    </span>
                  </div>
                )}

                {userinfo?.stripeReason && (
                  <div>
                    Stripe:&nbsp;
                    <span style={{ color: "red" }}>
                      {userinfo?.stripeReason}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Popover>


      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationDetails);

